export default function formatDollars(number) {
  const numberRounded = Math.round(number);
  const numberWithCommas = numberRounded
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return "$" + numberWithCommas;
}
